import {
  FETCH_MOBILE_UPDATES_REQUEST,
  FETCH_MOBILE_UPDATES_SUCCESS,
  FETCH_MOBILE_UPDATES_ERROR,
  UPDATE_MOBILE_UPDATE_REQUEST,
  UPDATE_MOBILE_UPDATE_SUCCESS,
  UPDATE_MOBILE_UPDATE_ERROR,
  REMOVE_MOBILE_UPDATE_SUCCESS,
  REMOVE_MOBILE_UPDATE_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_MOBILE_UPDATES_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_MOBILE_UPDATES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_MOBILE_UPDATES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case UPDATE_MOBILE_UPDATE_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_MOBILE_UPDATE_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
          updated: true,
          removed: false,
        },
      }

    case UPDATE_MOBILE_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: action.payload,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case REMOVE_MOBILE_UPDATE_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: null,
          updated: false,
          removed: true,
        },
      }

    case REMOVE_MOBILE_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          removed: false,
        },
      }

    default:
      return state
  }
}

export default record
